"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _IDate = _interopRequireDefault(require("../../../common/iObjects/IDate"));

var _IPeriod = _interopRequireDefault(require("../../../common/iObjects/IPeriod"));

var _IAccount = _interopRequireDefault(require("../../../common/iObjects/IAccount"));

var _ICurrency = _interopRequireDefault(require("../../../common/iObjects/ICurrency"));

var _IPhone = _interopRequireDefault(require("../../../common/iObjects/IPhone"));

var _IOTP = _interopRequireDefault(require("../../../common/iObjects/IOTP"));

var _INumber = _interopRequireDefault(require("../../../common/iObjects/INumber"));

var _ICVV = _interopRequireDefault(require("../../../common/iObjects/ICVV"));

var _IEmail = _interopRequireDefault(require("../../../common/iObjects/IEmail"));

var _dataModel = _interopRequireDefault(require("../../../common/backbone/dataModel"));

var _dataCollection = _interopRequireDefault(require("../../../common/backbone/dataCollection"));

var _crud = _interopRequireDefault(require("../sync/crud.sync"));

var _stream = _interopRequireDefault(require("../sync/stream.sync"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default =
/*#__PURE__*/
function (_DataModel) {
  (0, _inherits2["default"])(_default, _DataModel);

  /**
   * // list of attributes settings
   * format
   * max
   * min
   * fieldConstructor
   * allowedValues
   * validate
   * notNull
   * validateOptions
   * validateMethod
   * parser
   * value
   */
  function _default(attributes) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, _default);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).call(this, attributes, options));

    _this._setPropertyAlias();

    _this._setQueryAlias();

    _this._setDefaults();

    _this.syncEngines = {};
    return _this;
  }
  /**
   * REST without UPDATE
   * override for pure REST API
   * original method - return !!this.id
   * @return {boolean}
   */


  (0, _createClass2["default"])(_default, [{
    key: "isNew",
    value: function isNew() {
      return true;
    }
  }, {
    key: "parse",
    value: function parse(data, options) {
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'read';
      var proto = Object.getPrototypeOf(this),
          ctr = proto.constructor;
      var attrs = data,
          parsers;
      parsers = this.parsers || ctr.parsers;
      parsers = (0, _typeof2["default"])(parsers) === 'object' ? parsers : {};

      if (typeof parsers[method] === 'function') {
        attrs = parsers[method].call(this, data, options);
      }

      return attrs;
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.sync('read', options);
    }
  }, {
    key: "destroy",
    value: function destroy(options) {
      return this.sync('destroy', options);
    }
  }, {
    key: "save",
    value: function save(key, val, options) {
      var attrs; // Handle both `"key", value` and `{key: value}` -style arguments.

      if (key === null || (0, _typeof2["default"])(key) === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      } // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.


      if (attrs && !this.set(attrs, options)) return false;
      options = _objectSpread({
        validate: true
      }, options); // Do not persist invalid models.

      if (!this._validate(attrs, options)) return false;
      return this.isNew() ? this.sync('create', options) : this.sync('update', options);
    }
  }, {
    key: "connect",
    value: function connect(options) {
      return _stream["default"].call(this, 'connect', options);
    }
  }, {
    key: "send",
    value: function send(options) {
      return _stream["default"].call(this, 'send', options);
    }
  }, {
    key: "set",
    value: function set(key, val) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var attrs, prop;

      if ((0, _typeof2["default"])(key) === 'object') {
        attrs = key;
        options = val || {};
      } else {
        (attrs = {})[key] = val;
      }

      var fields = this._getFields();

      for (prop in attrs) {
        if (attrs.hasOwnProperty(prop)) {
          if (fields[prop]) {
            attrs[prop] = this._prepareValue(prop, attrs[prop], options);
          }
        }
      }

      return (0, _get2["default"])((0, _getPrototypeOf2["default"])(_default.prototype), "set", this).call(this, attrs, options);
    }
  }, {
    key: "validate",
    value: function validate() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.attributes;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var fields = this._getFields();

      var name, val, error, validateOptions;

      for (name in attrs) {
        if (attrs.hasOwnProperty(name) && fields[name]) {
          var forceValidation = fields[name].forceValidation;

          if (typeof forceValidation === 'function') {
            forceValidation = forceValidation.call(this, attrs);
          }

          if (!forceValidation) {
            val = this._prepareValue(name, attrs[name]);
            validateOptions = fields[name].validateOptions || [];
            validateOptions = validateOptions instanceof Array ? validateOptions : [validateOptions];

            if (fields[name].notNull && val === null) {
              error = this._handleError(name, 'notNull');
              break;
            }

            if (val && typeof val.validate === 'function') {
              var _val;

              var validation = (_val = val).validate.apply(_val, (0, _toConsumableArray2["default"])(validateOptions)); // DataModel validation returns object in error case


              if (val instanceof _dataModel["default"] && validation) {
                error = this._handleError(name, 'fieldConstructor', {
                  fieldConstructorError: validation
                });
                break;
              } else if (!(val instanceof _dataModel["default"]) && !validation) {
                error = this._handleError(name, 'fieldConstructor');
                break;
              }
            }

            if (val !== null && fields[name].allowedValues && fields[name].allowedValues.indexOf && fields[name].allowedValues.indexOf(val) < 0) {
              error = this._handleError(name, 'allowedValues');
              break;
            }

            if (typeof fields[name].validate === 'function' && (error = fields[name].validate.call(this, val, attrs))) {
              error = this._handleError(name, error.message || error, error);
              break;
            }

            if (val !== null && !isNaN(fields[name].min) && (val instanceof _INumber["default"] ? val.toFloat() : +val) < fields[name].min) {
              error = this._handleError(name, 'min', {
                n: fields[name].min
              });
              break;
            }

            if (val !== null && fields[name].max && (val instanceof _INumber["default"] ? val.toFloat() : +val) > fields[name].max) {
              error = this._handleError(name, 'max', {
                n: fields[name].max
              });
              break;
            } // stringify value


            if (val !== null && !(val instanceof _dataModel["default"]) && !(val instanceof _dataCollection["default"])) {
              if (fields[name].validateMethod && typeof val[fields[name].validateMethod] === 'function') {
                var _val2;

                val = (_val2 = val)[fields[name].validateMethod].apply(_val2, (0, _toConsumableArray2["default"])(validateOptions));
              } else if (typeof val.toString === 'function') {
                var _val3;

                val = validateOptions ? (_val3 = val).toString.apply(_val3, (0, _toConsumableArray2["default"])(validateOptions)) : String(val);
              }
            }

            if (val !== null && fields[name].format && !fields[name].format.test(val)) {
              error = this._handleError(name, 'format');
              break;
            }
          }
        }
      }

      if (!options.validateValueOnly && !error && typeof this.extraValidate === 'function') {
        error = this.extraValidate(attrs, options);
      }

      return error;
    }
    /**
     * @return {object}
     * @private
     */

  }, {
    key: "_setPropertyAlias",
    value: function _setPropertyAlias() {
      var proto = Object.getPrototypeOf(this),
          ctr = proto.constructor;

      if (this.hasOwnProperty('fields') && process && process.env.NODE_ENV !== 'production') {
        window.console.warn('Base.Models.Base "fields" is not static. It may cause an incorrect behaviour.');
      }

      if (!proto.hasOwnProperty('__property_alias_was_set__')) {
        proto.fields = ctr.fields;
        proto.validationMessages = ctr.validationMessages;
        proto.parsers = ctr.parsers;
        proto.queryParams = ctr.queryParams;
        proto.__property_alias_was_set__ = true;
      }

      return this;
    }
    /**
     * set alias methods for query settings
     * query settings must be assigned in static variable "queryParams"
     * ex: queryParams.doQuery -> this.__proto__.duQuery
     * @return {object}
     * @private
     */

  }, {
    key: "_setQueryAlias",
    value: function _setQueryAlias() {
      var proto = Object.getPrototypeOf(this);

      if (!proto.hasOwnProperty('__query_alias_was_set__')) {
        if ((0, _typeof2["default"])(this.queryParams) === 'object') {
          var name;
          var crud = ['create', 'read', 'update', 'destroy'],
              stream = ['connect', 'send'];

          for (name in this.queryParams) {
            if (this.queryParams.hasOwnProperty && this.queryParams.hasOwnProperty(name) && crud.indexOf(name) < 0 && stream.indexOf(name) < 0) {
              (function (method) {
                proto[method] = function () {
                  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  return this.sync(method, options);
                };
              })(name);
            }
          }
        }

        proto.__query_alias_was_set__ = true;
      }

      return this;
    }
    /**
     * create error object
     * @param {string} name
     * @param {string} type
     * @param {object} options
     * @return {object}
     */

  }, {
    key: "_handleError",
    value: function _handleError(name, type) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var proto = Object.getPrototypeOf(this),
          ctr = proto.constructor,
          fields = this._getFields();

      var validationMessages;
      validationMessages = proto.hasOwnProperty('validationMessages') ? proto.validationMessages : ctr.validationMessages;
      validationMessages = (0, _typeof2["default"])(fields) === 'object' ? validationMessages : {};
      return {
        name: name,
        message: fields[name].validationMessages && fields[name].validationMessages[type] || validationMessages[type] || type,
        options: options
      };
    }
    /**
     * Проставляет значения аттрибутов по умолчанию
     * Значения в аттрибуты проставляет fields
     * @private
     * @return {object}
     */

  }, {
    key: "_setDefaults",
    value: function _setDefaults() {
      var fields = this._getFields(),
          attrs = {};

      var name,
          fieldValue,
          needToSet = false;

      for (name in fields) {
        if (fields.hasOwnProperty(name)) {
          fieldValue = fields[name] && fields[name].value; // если значение небыло передано в конструктор
          // или не определено в defaults
          // берем его из fields.name.value

          if (this.attributes[name] === undefined && fieldValue !== undefined) {
            needToSet = true;
            attrs[name] = fieldValue;
          }
        }
      }

      if (needToSet) {
        // for ID attribute setting
        this.set(attrs, {
          silent: true,
          validate: false
        });
      }

      return this;
    }
    /**
     * приводит значение к конструктору, если он есть
     * если значение undefined|null|"" - приводит к null
     * @param {string} name
     * @param {*} value
     * @param {object} options
     * @return {*}
     * @private
     */

  }, {
    key: "_prepareValue",
    value: function _prepareValue(name, value, options) {
      var fields = this._getFields(),
          settings = fields[name],
          fieldCtr = (0, _typeof2["default"])(settings) === 'object' ? settings.fieldConstructor : null; // 0 в этом случае валидное значение


      if (value === '' || value === undefined) {
        value = null;
      }

      if (settings && value !== null && typeof settings.parser === 'function') {
        value = settings.parser.call(this, value, options);
        value = value === undefined || value === '' ? null : value;
      }

      if (fieldCtr) {
        if (typeof fieldCtr === 'function') {
          value = this._createFieldConstructor(value, fieldCtr, options);
        } else if (value !== null && (0, _typeof2["default"])(value) === 'object' && (0, _typeof2["default"])(fieldCtr) === 'object') {
          for (var attr in fieldCtr) {
            if (fieldCtr.hasOwnProperty(attr) && value[attr] !== '' && value[attr] !== null && value[attr] !== undefined) {
              value[attr] = this._createFieldConstructor(value[attr], fieldCtr[attr], options);
            }
          }
        }
      }

      return value;
    }
  }, {
    key: "_createFieldConstructor",
    value: function _createFieldConstructor(value, Constructor, options) {
      if (value === null || value instanceof Constructor) {
        return value;
      } else {
        return new Constructor(value, options);
      }
    }
    /**
     *  this.fields || this.prototype.fields || this.__proto__.constructor.fields
     in case of .set from constructor we take this.__proto__.constructor.fields
     otherwise we take this.prototype.fields, because it was set to proto in ._setPropertyAlias
     * @return {object}
     * @private
     */

  }, {
    key: "_getFields",
    value: function _getFields() {
      var fields = {};
      var proto = Object.getPrototypeOf(this),
          ctr = proto.constructor;

      if (this.hasOwnProperty('fields')) {
        fields = this.fields;
      } else if (proto.hasOwnProperty('fields')) {
        fields = proto.fields;
      } else if ((0, _typeof2["default"])(ctr.fields) === 'object') {
        fields = ctr.fields;
      }

      return fields;
    }
  }, {
    key: "toDefaults",
    value: function toDefaults() {
      this.attributes = {};

      this._setDefaults();

      this.changed = {};
      this.validationError = null;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _this2 = this;

      var json = {},
          keys = Object.keys(this.attributes);
      var value;
      keys.forEach(function (key) {
        value = _this2.attributes[key];

        if (value instanceof _dataCollection["default"] || value instanceof _dataModel["default"]) {
          json[key] = value.toJSON();
        } else if (value instanceof _INumber["default"]) {
          json[key] = value.toFloat();
        } else if (value instanceof _IDate["default"] || value instanceof _IPeriod["default"] || value instanceof _IAccount["default"] || value instanceof _ICurrency["default"] || value instanceof _IPhone["default"] || value instanceof _IOTP["default"] || value instanceof _ICVV["default"] || value instanceof _IEmail["default"]) {
          json[key] = value.toString();
        } else {
          json[key] = value;
        }
      });
      return json;
    }
  }, {
    key: "sync",
    value: function sync() {
      for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
        rest[_key] = arguments[_key];
      }

      return _crud["default"].call.apply(_crud["default"], [this].concat(rest));
    }
  }, {
    key: "syncResolve",
    value: function syncResolve() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.set(data, options);
      return this;
    }
    /**
     * @return {object} singleton of this class
     */

  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.prototype.singletonInstance) {
        var parent = this,
            Surrogate;

        Surrogate = function Surrogate() {
          var _parent$prototype$con;

          for (var _len3 = arguments.length, rest = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            rest[_key3] = arguments[_key3];
          }

          // для того что бы принимать динамическое к-во аргументов в конструктор
          return (_parent$prototype$con = parent.prototype.constructor).call.apply(_parent$prototype$con, [this].concat(rest));
        };

        Surrogate.prototype = parent.prototype;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        this.prototype.singletonInstance = (0, _construct2["default"])(Surrogate, args);
      }

      return this.prototype.singletonInstance;
    }
    /**
     * @return {object} Model instance with cloned fields.
     */

  }, {
    key: "getClone",
    value: function getClone() {
      var parent = this,
          Surrogate,
          clone,
          fields = {}; // для того что бы принимать динамическое к-во аргументов в конструктор

      Surrogate = function Surrogate() {
        var _parent$prototype$con2;

        for (var _len5 = arguments.length, rest = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          rest[_key5] = arguments[_key5];
        }

        return (_parent$prototype$con2 = parent.prototype.constructor).call.apply(_parent$prototype$con2, [this].concat(rest));
      };

      Surrogate.prototype = parent.prototype;

      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      clone = (0, _construct2["default"])(Surrogate, args); // копия второго уровня для fields.

      if (clone.fields) {
        var keys = Object.keys(clone.fields),
            settings;
        keys.forEach(function (name) {
          // значения fields[attribute].param копируются по ссылке/значению в зависимости от содержимого
          settings = clone.fields[name] || {};
          fields[name] = _objectSpread({}, settings);
        });
      }

      clone.fields = fields;
      return clone;
    }
  }]);
  return _default;
}(_dataModel["default"]);

exports["default"] = _default;
(0, _defineProperty2["default"])(_default, "fields", {});
(0, _defineProperty2["default"])(_default, "validationMessages", {
  notNull: 'ERROR_VALUE_IS_EMPTY',
  allowedValues: 'ERROR_OUT_OF_ALLOWED_LIST',
  format: 'ERROR_WRONG_FORMAT',
  min: 'ERROR_LESS_THEN_MINIMAL',
  max: 'ERROR_GREATER_THEN_MAXIMUM',
  fieldConstructor: 'ERROR_FIELD_CONSTRUCTOR'
});